import { toast } from "react-toastify";

export const validateEmail = (email, t) => {
  if (!email.trim()) {
    return toast.error(t("global.errorEmail.empty"));
  }
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  if (!emailPattern.test(email)) {
    return toast.error(t("global.errorEmail.format"));
  }
};
